<script setup>
// eslint-disable-next-line
clearError({
  redirect: '/404'
})
</script>

<template>
  <div>
    <h1>Error Page</h1>
  </div>
</template>
